<template lang="pug">
#alert(
	:class="{dismiss: !aggressive}"
)
	div
		span.warn &#9888;
		button.secondary.button-close.close(@click="dismiss"): include ../resources/icons/chevron-down.pug
		p Main Calendar is not set up
		p Events Scheduling, Contracts, and Invoices need a set Main Calendar to function
	template(v-for="(j,i) in props.mainCalendar" :key="`i-${i}`")


</template>

<script setup lang="ts">
import {ref} from 'vue';

const props = defineProps<{mainCalendar:any}>();
const aggressive = ref<boolean>(true);

const dismiss = () => {
	aggressive.value = !aggressive.value;
};

</script>

<style lang="scss">
#alert{
	position: absolute;
	top:  6rem;
	left: 1rem;
	width: clamp(5rem, auto, 18rem);
	max-width: 18rem;
	height: fit-content;
	text-align: center;
	transition: all 500ms cubic-bezier(.95,1.5,.6,.8);
	transform: translate(0, 0);

	div{
		position: relative;
		height: fit-content;
		padding: 1rem;
		background-color: $color-white;
		border: 2px dashed $color-red;
		border-radius: 0.25rem;
		box-shadow: 0 0 16px 4px rgba($color-red, 0.7);
		box-shadow: 4px 4px $color-red;
	}

	button{
		position: absolute;
		top: .25rem;
		right: .25rem;
		left: unset;
		width: 2rem;
		height: 2rem;
		min-height: 2rem;
		padding: 2px;
		border-radius: 4px;
		box-shadow: unset;
	}

	button svg{
		transform: rotate(0);
	}

	button:hover, button:active, button:focus{
		 svg path{
			fill: $color-black;
		}
	}

	p{
		// position: relative;
		margin: 1rem;
	}

	p:first-of-type{
		margin-top: unset;
		font-weight: bold;
	}

	.warn{
		margin: auto;
		font-size: 32px;
		color: $color-red;
	}

	&.dismiss{
		transform: translate(0, calc(100vh - 200% + 1rem));

		div{
			border-style: solid;
			box-shadow: $shadow-black-2;
		}
		svg{transform: rotate(180deg);}
	}

}

</style>